import React from 'react'
import { OrganizationTabPaneProps } from '../../../../../Types/ContactType'
import { H4, H6, Image, LI, P, UL } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Utils'
import { EmailAddress, Gender, General, Href, Personal, Print } from '../../../../../Utils/Constants'

export default function OrganizationTabPane({ user }: OrganizationTabPaneProps) {
  return (
    <div className='profile-mail'>
      <div className="d-flex">
        <Image className='img-100 img-fluid m-r-20 rounded-circle update_img_5' src={dynamicImage(user.image)} alt='' />
        <div className="flex-grow-1 mt-0">
          <H4>
            <span className='first_name_5'>{user.name}</span>
          </H4>
          <P className='email_add_5'>{user.email}</P>
          <UL className='simple-list'>
            <LI><a href={Href}>{Print}</a></LI>
          </UL>
        </div>
      </div>
      <div className='email-general'>
        <H6>{General}</H6>
        <P>{EmailAddress}: <span className='font-primary email_add_5'>{user.email}</span></P>
        <div className='gender'>
          <H6>{Personal}</H6>
          <P>{Gender}: <span>{user.gender}</span></P>
        </div>
      </div>
    </div>
  )
}
